function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(241, 241, 241)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'250g': 'url("//goodbean.coffee/cdn/shop/files/250g_68x.png?v=16266858773639120249")','500g': 'url("//goodbean.coffee/cdn/shop/files/500g_68x.png?v=4168456758228439741")','2500g': 'url("//goodbean.coffee/cdn/shop/files/2500g_68x.png?v=6136187193016406731")','2-x-500g': 'url("//goodbean.coffee/cdn/shop/files/2x500g_68x.png?v=670834215123398377")','4-x-500g': 'url("//goodbean.coffee/cdn/shop/files/4x500g_68x.png?v=15026722782666329522")','3-x-250g': 'url("//goodbean.coffee/cdn/shop/files/3x250g_68x.png?v=3477251328288730313")','3-x-500g': 'url("//goodbean.coffee/cdn/shop/files/3x500g_68x.png?v=1573003355485669212")','ganze-bohne': 'url("//goodbean.coffee/cdn/shop/files/Mahlgrad-ganzeBohne_68x.png?v=8081586593317787570")','gemahlen-fur-french-press-cold-brew': 'url("//goodbean.coffee/cdn/shop/files/Mahlgrad-8_68x.png?v=4217895684308638919")','gemahlen-fur-handfilter-filterkaffeemaschine-chemex': 'url("//goodbean.coffee/cdn/shop/files/Mahlgrad-6_68x.png?v=12563910894139110878")','gemahlen-fur-herdkanne-aero-press': 'url("//goodbean.coffee/cdn/shop/files/Mahlgrad-4_68x.png?v=17241968800183052725")','gemahlen-fur-siebtrager-espresso': 'url("//goodbean.coffee/cdn/shop/files/Mahlgrad-2_68x.png?v=11574661301383147604")',};

    this.triggers = ['menge wählen','mahlgrad wählen',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
